(function(Header, $, undefined) {

  var initStickyNavListener = function() {
    $(document).on('ss.scrollDirectionChanged', function(e, data) {
      switch (data.direction) {
        case 'up':
          $('body').addClass('sticky-nav-active--w-header');
          break;
        case 'down':
          $('body').removeClass('sticky-nav-active--w-header');
          break;
        default:
          break;
      }
    });
  }

  var initHeaderStyleChange = function() {
    const scrollTopOffset = $(window).scrollTop();
    if (scrollTopOffset > 0) {
      $('.site-header').removeClass('site-header--transparent');
    } else {
      $('.site-header').addClass('site-header--transparent');
    }
  }

  var determineHeaderStyle = function() {
    if ($('.cta-hero').length > 0) {
      $('body').addClass('transparent-header')
      $('.site-header').addClass('site-header--transparent');

      $(document).on('ready', function() {
        initHeaderStyleChange();
      })
  
      $(window).on('scroll', function() {
        initHeaderStyleChange();
      })
    }
  }

  var bindUIActions = function() {
    $('[data-toggle-mobile-nav]').on('click', function() {
      $('body').toggleClass('scroll-lock');
      $('.hamburger').toggleClass('active');
      $('.site-header__nav').slideToggle();
      if ($('.inline-cart').is(':visible')) {
        $('body').removeClass('cart-open');
      }
    })

    $('body').on('click', function() {
      $('.site-header__linklist-sub').slideUp(300);
      $('.site-header__link').removeClass('site-header__link--highlighted')
    })

    $('[data-is-owner]').on('click', function(e) {
      e.preventDefault();
      var isOwner = $(this).attr('data-is-owner') === 'true';
      var trackName = isOwner ? 'Support Clicked by Owner' : 'Support Clicked by Non-Owner';
      analytics.track(trackName);
      setCookie('ss.isOwner', isOwner);
    })
    
    $('[data-toggle-submenu]').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      if (!$(this).hasClass('site-header__link--highlighted')) {
        $(this).closest('ul').find('> li > ul').slideUp(300);
        $(this).closest('ul').find('> li > a').removeClass('site-header__link--highlighted');
      } else {
        $(this).next().find('.site-header__linklist-sub').slideUp(300);
        $(this).next().find('.site-header__link--highlighted').removeClass('site-header__link--highlighted');
      }
      $(this).closest('.site-header__linklist-item--has-sub').siblings().find('.site-header__linklist-sub').slideUp();
      $(this).closest('.site-header__linklist-item--has-sub').siblings().find('.site-header__link--highlighted').removeClass('site-header__link--highlighted');
      $(this).next().slideToggle(300);
      $(this).toggleClass('site-header__link--highlighted');
    })
  }

  Header.init = function() {
    if ($('[data-sticky-nav-trigger]').length) {
      initStickyNavListener();
    }
    determineHeaderStyle();
    bindUIActions();
  }

}(window.Header = window.Header || {}, jQuery));